import { IQuoteSettingsConfigSchema } from '@monetize/types/app';
import { useEffect } from 'react';
import { MAccordion, MStack } from '../../../../../components/Monetize';
import { MSettingAccordionItem } from '../../../../../components/Monetize/MSettingAccordionItem';
import { useAccordionControl } from '../../../../../hooks';
import {
  getHighlightStyles,
  useSettingsSectionHighlight,
} from '../../../../../hooks/useSettingsSectionHighlight';
import { QUOTE_SETTING_KEYS } from '../quoteSettingsConfig';
import { QuoteEsignSettingsDefaultSigningContacts } from './QuoteEsignSettingsDefaultSigningContacts';
import { QuoteEsignSettingsSigningOrder } from './QuoteEsignSettingsSigningOrder';

interface QuoteEsignSettingsProps {
  quoteSettings: IQuoteSettingsConfigSchema;
  onSubmit: (data: Partial<IQuoteSettingsConfigSchema>) => Promise<void>;
}

export const QuoteEsignSettings = ({
  quoteSettings,
  onSubmit,
}: QuoteEsignSettingsProps) => {
  const isEsignHighlighted = useSettingsSectionHighlight(
    QUOTE_SETTING_KEYS.quoteEsignSettings,
  );
  const isContactsHighlighted = useSettingsSectionHighlight(
    QUOTE_SETTING_KEYS.quoteEsignDefaultContacts,
  );
  const isOrderHighlighted = useSettingsSectionHighlight(
    QUOTE_SETTING_KEYS.quoteEsignSigningOrder,
  );
  const shouldOpen =
    isEsignHighlighted || isContactsHighlighted || isOrderHighlighted;

  const { accordionValue, handleAccordionChange, setAccordionValue } =
    useAccordionControl();

  useEffect(() => {
    if (shouldOpen) {
      setAccordionValue(['0']);
    }
  }, [shouldOpen, setAccordionValue]);

  return (
    <MStack w="100%" data-testid="quoteEsignSettings">
      <MAccordion
        multiple
        w="full"
        value={accordionValue}
        onValueChange={({ value }) => handleAccordionChange(value)}
      >
        <MSettingAccordionItem
          value="0"
          id={QUOTE_SETTING_KEYS.quoteEsignSettings}
          {...getHighlightStyles(isEsignHighlighted)}
          label="Quote eSign Settings"
          borderWidth="1px"
        >
          <QuoteEsignSettingsDefaultSigningContacts />

          <QuoteEsignSettingsSigningOrder
            quoteSettings={quoteSettings}
            onSubmit={onSubmit}
          />
        </MSettingAccordionItem>
      </MAccordion>
    </MStack>
  );
};
